import { DepositoStore, DEPOSITO_STORE } from './Deposito';
import { MonografiaStore, MONOGRAFIA_STORE } from './Monografia';
import { ProfessorStore, PROFESSOR_STORE } from './Professor';
import { AgendamentoStore, AGENDAMENTO_STORE } from './Agendamento';
import {AlunoStore, ALUNO_STORE} from './Aluno';
import { AuthStore, AUTH_STORE } from './Auth';
import { ChatStore, CHAT_STORE } from './Chat';
import {PreProjetoStore, PREPROJETO_STORE} from './PreProjeto';

export class RootStore {
  monografiaStore: MonografiaStore;
  depositoStore: DepositoStore;
  professorStore: ProfessorStore;
  agendamentoStore: AgendamentoStore;
  alunoStore: AlunoStore;
  chatStore: ChatStore;
  authStore: AuthStore;
  preProjetoStore: PreProjetoStore;

  constructor() {
    this.monografiaStore = new MonografiaStore(this);
    this.depositoStore = new DepositoStore(this);
    this.professorStore = new ProfessorStore(this);
    this.agendamentoStore = new AgendamentoStore(this);
    this.alunoStore = new AlunoStore(this);
    this.chatStore = new ChatStore(this);
    this.authStore = new AuthStore();
    this.preProjetoStore = new PreProjetoStore(this);
  }
  createStores() {

    return {
      [MONOGRAFIA_STORE]: this.monografiaStore,
      [DEPOSITO_STORE]: this.depositoStore,
      [PROFESSOR_STORE]: this.professorStore,
      [AGENDAMENTO_STORE]: this.agendamentoStore,
      [ALUNO_STORE]: this.alunoStore,
      [CHAT_STORE]: this.chatStore,
      [AUTH_STORE]: this.authStore,
      [PREPROJETO_STORE]: this.preProjetoStore,
    };
  }
}